module.exports = __webpack_public_path__ + "media/img/help_center/Student_Scholarship_Search_01-e43ce72ebc95a70698b1372d3d408c02.jpg";